import createTheme from '@mui/material/styles/createTheme';
import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { HorizonWhiteLogo, Horizon, GCLogo } from 'shared-components/images';

const LinkBehavior = React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }>(
  (props, ref) => {
    const { href, ...other } = props;
    // Map href (Material UI) -> to (react-router)
    return <RouterLink ref={ref} to={href} {...other} />;
  },
);

const Logo = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <HorizonWhiteLogo />
    </div>
  );
});

const DarkLogo = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <Horizon />
    </div>
  );
});

const LogoOnly = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref}>
      <GCLogo />
    </div>
  );
});

const favicon =
  'data:image/png;base64,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';

const { palette } = createTheme({
  palette: {
    text: {
      primary: '#2E2E2E',
      secondary: '#2E2E2E99',
      disabled: '#2E2E2E80',
    },
    primary: {
      main: '#008850',
      dark: '#006D40',
      light: '#33A073',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#585858',
      dark: '#3A3A3A',
      light: '#0088501F',
      contrastText: '#FFFFFF',
    },
    action: {
      active: '#008850',
      activatedOpacity: 1,
      hover: '#0088500A',
      hoverOpacity: 0.04,
      selected: '#e0efe9',
      selectedOpacity: 0.12,
      focus: '#00885029',
      focusOpacity: 0.16,
      disabledBackground: '#0000000F',
      disabled: '#00000061',
      disabledOpacity: 0.38,
    },
    error: {
      main: '#D42C2C',
      dark: '#B81718',
      light: '#F09999',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#E57C00',
      dark: '#D55200',
      light: '#fdf5db',
      contrastText: '#2E2E2E',
    },
    info: {
      main: '#2476CE',
      dark: '#17489C',
      light: '#8FC2EF',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#008850',
      dark: '#006D40',
      light: '#33A073',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      secondary: '#F5FAF8',
      paper: '#FFFFFF',
    },
    statusColors: {
      simulation: '#fbbc05',
      prescription: '#00a963',
      plan: '#00a3e1',
      cpot: '#e57c00',
      dxSubmitted: '#AAA1FD',
      draft: '#CFCDC9',
    },
    alert: {
      infoFill: '#F0F7FD',
    },
    statusContrastText: {
      simulation: '#FFFFFF',
      prescription: '#FFFFFF',
      plan: '#FFFFFF',
      cpot: '#FFFFFF',
      dxSubmitted: '#000000',
      draft: '#2E2E2E',
    },
    tag: {
      main: '#c86ba8',
    },
  },
});

const theme = createTheme({
  custom: {
    logo: <Logo />,
    darkLogo: <DarkLogo />,
    logoOnly: <LogoOnly />,
    favicon,
    title: 'Horizon',
    support: 'GenesisCare support',
  },
  palette,
  typography: {
    allVariants: {
      color: palette.text.primary,
    },
    fontFamily: 'Poppins, Arial',
    h1: {
      fontSize: 96,
      fontWeight: 300,
    },
    h2: {
      fontSize: 60,
      fontWeight: 300,
    },
    h3: {
      fontSize: 48,
      fontWeight: 400,
    },
    h4: {
      fontSize: 34,
      fontWeight: 400,
    },
    h5: {
      fontSize: 24,
      fontWeight: 400,
    },
    h6: {
      fontSize: 20,
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: 14,
      fontWeight: 500,
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
    },
    caption: {
      fontSize: 12,
      fontWeight: 400,
    },
    overline: {
      fontSize: 12,
      fontWeight: 400,
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
      styleOverrides: {
        root: {
          ':focus-visible': {
            outlineColor: palette.grey[300],
          },
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: 'black',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          color: palette.text.primary,
          textTransform: 'capitalize',
          fontWeight: 500,
          fontSize: '16px',
          borderRadius: '32px',
          '&.Mui-disabled': {
            color: palette.text.disabled,
          },
        },
        sizeLarge: {
          minWidth: '130px',
        },
        contained: {
          color: palette.primary.contrastText,
          backgroundColor: palette.primary.main,
        },
        outlined: {
          backgroundColor: palette.primary.contrastText,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        // darken error helper text
        root: {
          '&.Mui-error': {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          ':hover': { color: 'white' },
          ':is(.MuiFab-colorInherit, .MuiFab-default):hover': {
            color: 'inherit',
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.grey[300],
          color: palette.primary.dark,
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        // 'default' colours are error colours
        badge: {
          ':not([class*="MuiBadge-color"])': {
            backgroundColor: palette.error.main,
            color: palette.error.contrastText,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        // white text when hovered
        filled: {
          '&.MuiChip-clickable:hover': { color: 'white' },
          '&.MuiChip-colorDefault:hover': { color: 'unset' },
        },
        root: {
          // all avatar colour variants use text.primary besides primary
          '.MuiChip-avatar': {
            color: palette.text.primary,
          },
          '.MuiChip-avatarColorPrimary': {
            color: palette.primary.contrastText,
            backgroundColor: palette.primary.light,
          },
          // avatar background colours are color.light
          '.MuiChip-avatarColorSecondary': {
            backgroundColor: palette.grey[100],
          },
          '.MuiChip-avatarColorInfo': {
            backgroundColor: palette.info.light,
          },
          '.MuiChip-avatarColorWarning': {
            backgroundColor: palette.warning.light,
          },
          '.MuiChip-avatarColorError': {
            backgroundColor: palette.error.light,
          },
          '.MuiChip-avatarColorDefault': {
            // except default
            backgroundColor: palette.grey[300],
          },
          // arbitrary delete icon colour :(
          '.MuiChip-deleteIconColorDefault': {
            color: '#430098',
            opacity: 0.26,
          },
          // outlined variant uses dark version of respective colour
          '&.MuiChip-outlinedPrimary': {
            color: palette.primary.dark,
          },
          '&.MuiChip-outlinedSecondary': {
            color: palette.grey[600],
          },
          '&.MuiChip-outlinedInfo': {
            color: palette.info.dark,
          },
          '&.MuiChip-outlinedWarning': {
            color: palette.warning.dark,
          },
          '&.MuiChip-outlinedError': {
            color: palette.error.dark,
          },
          '&.MuiChip-outlinedDefault': {
            color: palette.primary.dark,
            borderColor: palette.action.active,
          },
          '&.MuiChip-colorDefault.MuiChip-clickable:hover': {
            backgroundColor: '#00885038',
          },
          // Fix for line-height issue in chip labels that is caused by reset.css
          '.MuiChip-label': {
            lineHeight: '1.5',
            padding: '0 8px',
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          // left line and background for selected
          '.MuiListItemButton-root.Mui-selected': {
            borderLeft: `4px solid ${palette.primary.main}`,
          },
          // border radius for all top-level list items
          '.MuiListItem-root, .MuiListItemButton-root': {
            borderRadius: '4px',
          },
          '.MuiListItem-gutters, .MuiListItemButton-gutters': {
            paddingLeft: '12px',
            paddingRight: 0,
          },
          // get rid of jank overlay radius onClick
          '.Mui-selected>.MuiTouchRipple-root': {
            borderRadius: '0px 4px 4px 0px',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          // close icon of filled variant must be dark
          '&.MuiAlert-filled.MuiAlert-closeIcon': {
            color: palette.text.primary,
          },
        },
      },
    },
    // prefer secondary colour for progress
    MuiLinearProgress: {
      defaultProps: {
        color: 'secondary',
      },
    },
    MuiCircularProgress: {
      defaultProps: {
        color: 'secondary',
      },
    },
    // snackbar action text should be secondary.light
    MuiSnackbarContent: {
      styleOverrides: {
        action: {
          color: palette.grey[100],
        },
      },
    },
    MuiPagination: {
      styleOverrides: {
        root: {
          // text and border colours
          '.MuiPaginationItem-outlinedSecondary': {
            borderColor: '#43009839', // totally arbitrary opacity, love it
            '&.Mui-selected': {
              color: palette.grey[600],
            },
          },
        },
      },
    },
    MuiStepLabel: {
      // step label uses dark version of color
      styleOverrides: {
        label: {
          '&.Mui-error': {
            color: palette.error.dark,
          },
        },
      },
    },
    MuiStepIcon: {
      // step icons must have 24px min width
      styleOverrides: {
        root: {
          minWidth: '24px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        // tab text is darker when secondary
        textColorSecondary: {
          '&.Mui-selected': {
            color: palette.grey[600],
          },
          '&.Mui-selected svg': {
            color: palette.grey[300],
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        // tab indicator is darker when secondary
        indicator: ({ ownerState: { indicatorColor } }) => ({
          backgroundColor: indicatorColor === 'secondary' ? palette.grey[600] : palette.primary.main,
        }),
      },
    },
    MuiIconButton: {
      styleOverrides: {
        // default colour is primary
        root: {
          ':not([class*="MuiIconButton-color"])': {
            color: palette.primary.main,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: palette.secondary.main,
          color: palette.secondary.contrastText,
          padding: '6px 8px',
          fontFamily: 'Poppins, Arial',
          fontSize: '12px',
        },
        arrow: {
          color: palette.secondary.main,
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          '&.MuiAutocomplete-popper>.MuiAutocomplete-paper': {
            '.Mui-selected': {
              backgroundColor: palette.action.focus,
              ':hover': {
                backgroundColor: palette.action.focus,
              },
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            paddingLeft: '8px',
            input: {
              paddingLeft: 0,
            },
          },
        },
      },
    },
    // TODO: Look at this later. It is very difficult to set the MUI hover border color
    // (see https://github.com/mui/material-ui/blob/434c33fa9a3a4ad36047991fb9db15fd972f44fc/packages/mui-material/src/OutlinedInput/OutlinedInput.js#L44)
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: palette.grey[300],
          },
          '&.Mui-disabled': {
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: palette.grey[300],
            },
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          paddingLeft: '8px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          paddingLeft: '0',
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: palette.grey[100],
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '16px',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          fontWeight: 400,
          color: `${palette.text.primary} !important`,
          '&.MuiToggleButton-root.Mui-selected': {
            backgroundColor: palette.action.selected,
            color: palette.text.primary,
          },
          ':hover': {
            backgroundColor: palette.action.hover,
          },
        },
      },
    },
  },
  zIndex: {
    fab: 7200,
  },
});

export type PaletteColour =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'error'
  | 'warning'
  | 'info'
  | 'success'
  | 'text'
  | 'simulation'
  | 'tag';

export default theme;
